import  firebase from  "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var config = {
    apiKey: "AIzaSyApsY_OiAHcGkAZRWF1aSJ32NpewWdeOQI",
    authDomain: "nemu-9e3ee.firebaseapp.com",
    databaseURL: "https://nemu-9e3ee.firebaseio.com",
    projectId: "nemu-9e3ee",
    storageBucket: "nemu-9e3ee.appspot.com",
    messagingSenderId: "500475853922"
  };

  firebase.initializeApp(config);
  firebase.firestore();

export default firebase;